<template>
  <!-- 体脑激活-->
  <div class="shehuigongnengkaifake">
    <CertQuery :logo="Logo20" :type="'tnjh'" :color="'#294db0'" />
  </div>
</template>

<script>
import CertQuery from '../component/certQuery.vue'
import Logo20 from '@/assets/images/logo20.jpg'

export default {
  name: 'SheHuiGongNengKaiFa',
  components: {
    CertQuery
  },
  data() {
    return {
      Logo20
    }
  }
}
</script>